import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WokComponent } from './wok.component';
import { Route, RouterModule } from '@angular/router';
import { KButtonModule } from 'app/common/ui/k-button/k-button.module';

const routes: Route[] = [
  {
    path: '',
    component: WokComponent
  }
];

@NgModule({
  declarations: [
    WokComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    KButtonModule
  ],
  exports: [
    WokComponent
  ]
})
export class WokModule { }
